"use strict";

var get = require('lodash.get');
var makeAuthenticate = function makeAuthenticate(_ref) {
  var ORGS_NAMESPACE = _ref.ORGS_NAMESPACE,
    ROLES_NAMESPACE = _ref.ROLES_NAMESPACE,
    IMPERSONATOR_NAMESPACE = _ref.IMPERSONATOR_NAMESPACE,
    USER_CREATED_AT_NAMESPACE = _ref.USER_CREATED_AT_NAMESPACE,
    PLURALSIGHT_ID_NAMESPACE = _ref.PLURALSIGHT_ID_NAMESPACE,
    PLURALSIGHT_HANDLE_NAMESPACE = _ref.PLURALSIGHT_HANDLE_NAMESPACE,
    getDecodedToken = _ref.getDecodedToken;
  return function (options) {
    var skipCache = !!get(options, 'skipCache');
    return getDecodedToken({
      refetch: skipCache
    }).then(function (decoded) {
      var viewer = {
        id: get(decoded, 'sub'),
        organisationId: get(decoded, ORGS_NAMESPACE),
        impersonatorId: get(decoded, IMPERSONATOR_NAMESPACE),
        roles: get(decoded, ROLES_NAMESPACE),
        userCreatedAt: get(decoded, USER_CREATED_AT_NAMESPACE),
        pluralsightId: get(decoded, PLURALSIGHT_ID_NAMESPACE),
        pluralsightHandle: get(decoded, PLURALSIGHT_HANDLE_NAMESPACE)
      };
      var isAuthenticated = !!get(decoded, 'sub');
      if (!isAuthenticated) {
        throw new Error('User is not authenticated');
      }
      return {
        viewer: viewer
      };
    }).catch(function (error) {
      return {
        viewer: null,
        error: error
      };
    });
  };
};
module.exports = {
  makeAuthenticate: makeAuthenticate
};